<div class="change-password-shell">
  <div class="change-password-card">
    <form [formGroup]="changePasswordForm" (ngSubmit)="changePassword()" autocomplete="off" class="change-password-form">
      <div class="header-row">
        <div>
          <h4 class="title">Change Password</h4>
          <p class="subtitle">Update your password to keep your account secure.</p>
        </div>
        <button type="button" class="close-btn" (click)="closeModal()" aria-label="Close">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="form-group">
        <label>Current Password</label>
        <div class="input-group">
          <input [type]="passwordInputs.old_password.isShown ? 'text' : 'password'" formControlName="old_password"
            placeholder="Current password" class="form-control" />
          <span class="input-group-text" (click)="viewHidePassword('old_password')">
            <i class="bi" [ngClass]="passwordInputs.old_password.isShown ? 'bi-eye-slash' : 'bi-eye'"></i>
          </span>
        </div>
      </div>

      <div class="form-group">
        <label>New Password</label>
        <div class="input-group">
          <input [type]="passwordInputs.new_password.isShown ? 'text' : 'password'" formControlName="new_password"
            placeholder="New password" class="form-control" />
          <span class="input-group-text" (click)="viewHidePassword('new_password')">
            <i class="bi" [ngClass]="passwordInputs.new_password.isShown ? 'bi-eye-slash' : 'bi-eye'"></i>
          </span>
        </div>
      </div>

      <div class="form-group">
        <label>Confirm Password</label>
        <div class="input-group">
          <input [type]="passwordInputs.confirm_password.isShown ? 'text' : 'password'" formControlName="confirm_password"
            placeholder="Confirm new password" class="form-control" />
          <span class="input-group-text" (click)="viewHidePassword('confirm_password')">
            <i class="bi"
              [ngClass]="passwordInputs.confirm_password.isShown ? 'bi-eye-slash' : 'bi-eye'"></i>
          </span>
        </div>
      </div>

      <div *ngIf="
        changePasswordForm.get('confirm_password')?.touched &&
        changePasswordForm.get('confirm_password')?.value !==
          changePasswordForm.get('new_password')?.value
      ">
        <span class="error-massage">Passwords do not match</span>
      </div>

      <button type="submit" class="btn-submit" [disabled]="isLoading || changePasswordForm.invalid">
        <span *ngIf="!isLoading">Change Password</span>
        <span *ngIf="isLoading" class="loading-state">
          <span class="spinner-border spinner-border-sm" role="status"></span>
          Updating password...
        </span>
      </button>
    </form>
  </div>
</div>